(function(){
  'use strict';
  function init(){
    document.querySelectorAll('form').forEach(function(form){
      var tags=form.querySelector('[name="contact[tags]"]');
      if(!tags||!tags.value.includes('newsletter')||form.dataset.signupBound)return;
      form.dataset.signupBound='true';var busy=false;
      form.addEventListener('submit',async function(event){
        event.preventDefault();if(busy||!form.reportValidity())return;
        var email=form.querySelector('[name="contact[email]"]'),name=form.querySelector('[name="contact[first_name]"]'),button=form.querySelector('[type="submit"]');
        var message=form.querySelector('[data-signup-feedback]');if(!message){message=document.createElement('p');message.className='signup-feedback';message.dataset.signupFeedback='';form.append(message);}
        message.hidden=true;busy=true;button.disabled=true;var buttonMarkup=button.innerHTML;button.innerHTML='<span class="signup-spinner" aria-hidden="true"></span><span class="visually-hidden">Subscribing</span>';form.setAttribute('aria-busy','true');
        var attrs={email:email.value.trim(),subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}};if(name)attrs.first_name=name.value.trim();
        try{
          /* Existing UNIFY public signup route and email list, unchanged. */
          var payload={data:{
            type:'subscription',
            attributes:{custom_source:'Website Signup',profile:{data:{type:'profile',attributes:attrs}}},
            relationships:{list:{data:{type:'list',id:'YjSvM4'}}}
          }};
          var response=await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=VgVM2W',{
            method:'POST',headers:{'Content-Type':'application/json','revision':'2025-04-15'},body:JSON.stringify(payload)
          });
          if(response.status!==202)throw new Error('Signup unavailable');
          message.setAttribute('role','status');message.textContent="You're in. Welcome to the movement.";message.hidden=false;
          form.dispatchEvent(new CustomEvent('unify:signup-success',{bubbles:true}));
          if(!form.closest('[data-welcome]'))form.querySelectorAll('input:not([type="hidden"]),button').forEach(function(e){e.disabled=true;});
        }catch(error){message.setAttribute('role','alert');message.textContent="That didn't go through. Please try again.";message.hidden=false;button.disabled=false;}
        finally{busy=false;button.innerHTML=buttonMarkup;form.removeAttribute('aria-busy');}
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
